import { render, staticRenderFns } from "./messageBoardEdit.vue?vue&type=template&id=c96fa880&scoped=true"
import script from "./messageBoardEdit.vue?vue&type=script&lang=js"
export * from "./messageBoardEdit.vue?vue&type=script&lang=js"
import style0 from "./messageBoardEdit.vue?vue&type=style&index=0&id=c96fa880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96fa880",
  null
  
)

export default component.exports